// Cards 71 and 72, the shoal stipple and the edge seam (R2713, R2726;
// ui-map-interface.md §17.3.71 and §17.3.72; mockup round 116 cards 05 and
// 09).
//
// The two marks of the feathered depth look are chart pieces, so a Chart
// theme turns each on or off per reading, and the DEPTH group of the VIEW
// panel hides them with the tints. The stipple is off in both readings of
// the pack and the seam on. Neither piece writes a quad: the depth pass of
// card 09 (`fast/layers/depth.ts`) draws both marks, and the scene hands
// the gate of each piece to the layer on every frame
// (`MapScene.setVisibility`), as it does for the tints. The stepped look
// draws neither mark (the lead's ruling, R2726).
//
// **IT DRAWS WHAT THE WIRE SENDS.** A world with no band field (the flag
// `depth` off) shows neither piece. The pieces read no flag (§14.1 rule 5).

import type { ChartContext, ChartSinks, Piece } from '../context';

/** One mark of the depth pass: a gate and nothing to pack. */
class DepthMarkPiece implements Piece {
  readonly tier = 'sea' as const;
  readonly pack = 'static' as const;
  readonly rebuildOn = [] as const;

  constructor(
    readonly id: 'shoal_stipple' | 'edge_seam',
    /** The stipple is the sea the fight happened in, so a replay film
     *  keeps it; the seam follows the own hulls of today, so a film hides
     *  it. */
    readonly film: 'keep' | 'hide',
  ) {}

  visible(ctx: ChartContext): boolean {
    return ctx.state.depthBands !== null;
  }

  rebuild(_ctx: ChartContext): void {
    // The marks are per-pixel. The depth layer holds every figure.
  }

  emit(_sinks: ChartSinks, _ctx: ChartContext): void {
    // Nothing. The picture is the depth layer's quad.
  }
}

/** Card 71: the shoal stipple, off until a Chart theme turns it on. */
export const shoalStipple = new DepthMarkPiece('shoal_stipple', 'keep');

/** Card 72: the edge seam near the own hulls, on until a theme turns it off. */
export const edgeSeam = new DepthMarkPiece('edge_seam', 'hide');
